<div class="pt-5 pb-4 position-relative"></div>
<div class="container mt-5">
  <div class="row text-start">
    <div class="col-md-12">
      <h3 class="text-start mb-4" style="color: var(--warna-2)">Manage Account</h3>
    </div>
  </div>
  <div class="row mb-4">
      <div class="col-md-12">
      <form [formGroup]="accountForm" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="card p-4 mb-5">
          <div class="row">
            <!-- Profile Form -->
            <div class="col-md-8">
              <h5 class="mb-3">Profile</h5>
            
               <!-- Name -->
               <div class="mb-3">
                <label for="name" class="form-label">Name</label>
                <input
                  type="text"
                  id="name"
                  class="form-control"
                  formControlName="name"
                />
                <div *ngIf="submitted && f['name'].invalid" class="text-danger mt-2">
                  <span *ngIf="f['name'].errors?.['required']">Name is required.</span>
                  <span *ngIf="f['name'].errors?.['minlength']">
                    Name must be at least 3 characters.
                  </span>
                </div>
              </div>
      
              <!-- Email -->
              <div class="mb-3">
                <label for="email" class="form-label">Email</label>
                <input
                  type="email"
                  id="email"
                  class="form-control"
                  formControlName="email"
                />
                <div *ngIf="submitted && f['email'].invalid" class="text-danger mt-2">
                  <span *ngIf="f['email'].errors?.['required']">Email is required.</span>
                  <span *ngIf="f['email'].errors?.['email']">Email is invalid.</span>
                </div>
              </div>

                <div class="mb-3">

                  <label for="phone" class="form-label d-flex justify-content-between">
                    <span>Phone Number</span>
                  
                    <span 
                    class="text-secondary" 
                    style="font-weight: bold; text-decoration: underline; cursor: pointer;" 
                    (click)="isPhoneAdded ? editPhoneNumber() : addPhoneNumber()"
                  >
                    {{ isPhoneAdded ? 'edit' : 'add' }}
                  </span>
                  </label>
              
                  <input 
                  #phoneInput
                  type="tel"
                  class="form-control"
                  id="phone"
                  formControlName="phone"
                  [disabled]="isDisabled"
                >
                <div *ngIf="isPhoneAdded" class="fst-italic">
                  <span class="text-success">Verified!</span> <span class="text-secondary"> This number can be used to log in.</span>
                </div>
                </div>

              

          
            </div>

            <!-- Profile Picture -->
            <div class="col-md-4 text-center">
              <div class="mb-3">
                <div
                  class="rounded-circle border border-secondary d-flex justify-content-center align-items-center"
                  style="width: 100px; height: 100px; margin: 0 auto; overflow: hidden;"
                >
                  <!-- Image or Icon -->
                  <img
                    *ngIf="profileImage"
                    [src]="profileImage"
                    alt="Profile"
                    class="img-fluid"
                    style="width: 100px; height: 100px; object-fit: cover;"
                    (error)="onImageError()"
                  />
                  <i *ngIf="!profileImage" class="fas fa-user-circle fa-6x text-secondary" style="font-weight: normal!important;"></i>
                </div>
              </div>
              <input
                type="file"
                accept="image/*"
                class="form-control d-none"
                id="imageUpload"
                (change)="onImageSelected($event)"
              />
              <label for="imageUpload" class="btn btn-outline-secondary btn-sm">Select Image</label>
              <span class="d-block mt-2 text-muted">File size: maximum 3MB</span>
            </div>
          </div>

          <!-- Password -->
          <hr />
          <div class="row">
            <div class="col-md-8">

              <div>
                <h5 class="mb-3">Password</h5>
                <div class="form-check mb-3">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="changePassword"
                    (change)="togglePasswordChange($event)"
                  />
                  <label class="form-check-label" for="changePassword">Change password</label>
                </div>
                <!-- Password Fields -->
                <div *ngIf="isPasswordChange" class="mt-3">
                
                  <div *ngIf="isPasswordChange && hasCurrentPassword" class="form-group mb-3 position-relative">
                    <label for="oldPassword" class="form-label">Current Password</label>
                    <div class="input-group">
                      <input
                        [type]="isPasswordVisible ? 'text' : 'password'"
                        id="oldPassword"
                        formControlName="oldPassword"
                        class="form-control"
                        (blur)="validateCurrentPassword()"
                      />
                      <i 
                        class="fa text-secondary" 
                        [ngClass]="isPasswordVisible ? 'fa-eye-slash' : 'fa-eye'" 
                        (click)="togglePasswordVisibility()" 
                        style="position: absolute; top: 35%; right: 10px; cursor: pointer; z-index: 5;" 
                        aria-hidden="true">
                      </i>
                    </div>
                    <div *ngIf="submitted && f['oldPassword']?.invalid" class="text-danger mt-2">
                      <small *ngIf="f['oldPassword']?.errors?.['required']">Old password is required.</small>
                      <small *ngIf="f['oldPassword']?.errors?.['invalidOldPassword']">Old password is incorrect.</small>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="newPassword" class="form-label">New Password</label>
                    <input
                      type="password"
                      formControlName="newPassword"
                      id="newPassword"
                      class="form-control"
                    />

                    <div *ngIf="submitted && f['newPassword']?.invalid" class="text-danger mt-2">
                      <small *ngIf="f['newPassword']?.errors?.['required']">New password is required.</small>
                      <small *ngIf="f['newPassword']?.errors?.['passwordStrength']">
                        Password must contain at least one uppercase letter and one number.
                      </small>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="confirmPassword" class="form-label">Confirm Password</label>
                    <input
                      type="password"
                      formControlName="confirmPassword"
                      id="confirmPassword"
                      class="form-control"
                    />

                    <div *ngIf="submitted && f['confirmPassword']?.invalid" class="text-danger mt-2">
                      <small *ngIf="f['confirmPassword']?.errors?.['required']">Confirm password is required.</small>
                      <small *ngIf="f['confirmPassword']?.errors?.['mismatch']">Passwords do not match.</small>
                    </div>
                  </div>
                </div>
                <button type="submit" class="btn btn-primary">
                  Save Changes
                </button>
              

            </div>

              <div class="col-md-4">

              </div>


          </div>


        </div>
        </div>
      </form>
    </div>
  </div>
</div>


<!-- Toast Notification -->
<div class="position-fixed bottom-0 end-0 p-3" style="z-index: 11">
  <div 
    *ngFor="let toast of toasts"
    class="toast show align-items-center text-white border-0" 
    role="alert" 
    aria-live="assertive" 
    aria-atomic="true"
    [ngClass]="{
      'bg-success': toast.type === EventTypes.Success,
      'bg-danger': toast.type === EventTypes.Error,
      'bg-warning': toast.type === EventTypes.Warning,
      'bg-info': toast.type === EventTypes.Info
    }">
    <div class="d-flex">
      <div class="toast-body">
        <strong>{{ toast.title }}</strong>
        <div>{{ toast.message }}</div>
      </div>
      <button type="button" 
              class="btn-close btn-close-white me-2 m-auto" 
              (click)="removeToast(toast)" 
              aria-label="Close">
      </button>
    </div>
  </div>
</div>
